import React from "react";
import { Space } from "antd";
import { AxTag, AxDivider, AxButton } from "@dynata/axiom3";

class Tags extends React.Component {
  render() {
    return (
      <div className="section" id="tags">
        <h3>Tags</h3>
        <p>Tag for categorizing or markup.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxTag size="medium" color="default">Medium</AxTag>`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/tag/#API"
                >
                  https://ant.design/components/tag/#API
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>Tag size</td>
                  <td>small | medium</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>color</td>
                  <td>Available color options</td>
                  <td>
                    default | dynata | primary | secondary | magenta | orange |
                    danger | warning | info | positive
                  </td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>suffix</td>
                  <td>Suffix icon</td>
                  <td>ReactNode</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>prefix</td>
                  <td>Prefix icon</td>
                  <td>ReactNode</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>closable</td>
                  <td>Whether the Tag can be closed</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>closeIcon</td>
                  <td>Custom close icon</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td>4.4.0</td>
                </tr>
                <tr>
                  <td>color</td>
                  <td>Color of the Tag</td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>icon</td>
                  <td>Set the icon of tag</td>
                  <td>ReactNode</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onClose</td>
                  <td>Callback executed when tag is closed</td>
                  <td>(e) =&gt; void</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/tag/#API"
                      >
                        {`<Tag />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div className="prop-header">
              <p className="props-title">Tag.CheckableTag</p>
            </div>
            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>checked</td>
                  <td>Checked status of Tag</td>
                  <td>boolean</td>
                  <td>false</td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>Callback executed when Tag is checked/unchecked</td>
                  <td>(checked) =&gt; void</td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxTag size="medium" color="dynata"> Dynata </AxTag>
<AxTag size="small" color="dynata"> Dynata </AxTag>`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Medium
        </AxDivider>

        <Space direction="vertical" size={30}>
          <Space>
            <AxTag size="medium" color="default">
              Medium
            </AxTag>

            <AxTag size="medium" color="dynata">
              Dynata
            </AxTag>

            <AxTag size="medium" color="primary">
              Primary
            </AxTag>

            <AxTag size="medium" color="secondary">
              Secondary
            </AxTag>

            <AxTag size="medium" color="magenta">
              Magenta
            </AxTag>

            <AxTag size="medium" color="orange">
              Orange
            </AxTag>

            <AxTag size="medium" color="danger">
              Danger
            </AxTag>

            <AxTag size="medium" color="warning">
              Warning
            </AxTag>

            <AxTag size="medium" color="info">
              Info
            </AxTag>

            <AxTag size="medium" color="positive">
              Positive
            </AxTag>
          </Space>

          <Space>
            <AxTag
              size="medium"
              color="default"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Medium
            </AxTag>

            <AxTag
              size="medium"
              color="dynata"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Dynata
            </AxTag>

            <AxTag
              size="medium"
              color="primary"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Primary
            </AxTag>

            <AxTag
              size="medium"
              color="secondary"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Secondary
            </AxTag>

            <AxTag
              size="medium"
              color="magenta"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Magenta
            </AxTag>

            <AxTag
              size="medium"
              color="orange"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Orange
            </AxTag>

            <AxTag
              size="medium"
              color="danger"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Danger
            </AxTag>

            <AxTag
              size="medium"
              color="warning"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Warning
            </AxTag>

            <AxTag
              size="medium"
              color="info"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Info
            </AxTag>

            <AxTag
              size="medium"
              color="positive"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Positive
            </AxTag>
          </Space>

          <Space>
            <AxTag
              size="medium"
              color="default"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Medium
            </AxTag>

            <AxTag
              size="medium"
              color="dynata"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Dynata
            </AxTag>

            <AxTag
              size="medium"
              color="primary"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Primary
            </AxTag>

            <AxTag
              size="medium"
              color="secondary"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Secondary
            </AxTag>

            <AxTag
              size="medium"
              color="magenta"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Magenta
            </AxTag>

            <AxTag
              size="medium"
              color="orange"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Orange
            </AxTag>

            <AxTag
              size="medium"
              color="danger"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Danger
            </AxTag>

            <AxTag
              size="medium"
              color="warning"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Warning
            </AxTag>

            <AxTag
              size="medium"
              color="info"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Info
            </AxTag>

            <AxTag
              size="medium"
              color="positive"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Positive
            </AxTag>
          </Space>

          <Space>
            <AxTag
              size="medium"
              color="default"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Medium
            </AxTag>

            <AxTag
              size="medium"
              color="dynata"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Dynata
            </AxTag>

            <AxTag
              size="medium"
              color="primary"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Primary
            </AxTag>

            <AxTag
              size="medium"
              color="secondary"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Secondary
            </AxTag>

            <AxTag
              size="medium"
              color="magenta"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Magenta
            </AxTag>

            <AxTag
              size="medium"
              color="orange"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Orange
            </AxTag>

            <AxTag
              size="medium"
              color="danger"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Danger
            </AxTag>

            <AxTag
              size="medium"
              color="warning"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Warning
            </AxTag>

            <AxTag
              size="medium"
              color="info"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Info
            </AxTag>

            <AxTag
              size="medium"
              color="positive"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Positive
            </AxTag>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Small
        </AxDivider>

        <Space direction="vertical" size={30}>
          <Space>
            <AxTag color="default">Medium</AxTag>

            <AxTag color="dynata">Dynata</AxTag>

            <AxTag color="primary">Primary</AxTag>

            <AxTag color="secondary">Secondary</AxTag>

            <AxTag color="magenta">Magenta</AxTag>

            <AxTag color="orange">Orange</AxTag>

            <AxTag color="danger">Danger</AxTag>

            <AxTag color="warning">Warning</AxTag>

            <AxTag color="info">Info</AxTag>

            <AxTag color="positive">Positive</AxTag>
          </Space>

          <Space>
            <AxTag
              color="default"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Medium
            </AxTag>

            <AxTag
              color="dynata"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Dynata
            </AxTag>

            <AxTag
              color="primary"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Primary
            </AxTag>

            <AxTag
              color="secondary"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Secondary
            </AxTag>

            <AxTag
              color="magenta"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Magenta
            </AxTag>

            <AxTag
              color="orange"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Orange
            </AxTag>

            <AxTag
              color="danger"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Danger
            </AxTag>

            <AxTag
              color="warning"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Warning
            </AxTag>

            <AxTag
              color="info"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Info
            </AxTag>

            <AxTag
              color="positive"
              suffix={<i className="fa-regular fa-xmark"></i>}
            >
              Positive
            </AxTag>
          </Space>

          <Space>
            <AxTag
              color="default"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Medium
            </AxTag>

            <AxTag
              color="dynata"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Dynata
            </AxTag>

            <AxTag
              color="primary"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Primary
            </AxTag>

            <AxTag
              color="secondary"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Secondary
            </AxTag>

            <AxTag
              color="magenta"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Magenta
            </AxTag>

            <AxTag
              color="orange"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Orange
            </AxTag>

            <AxTag
              color="danger"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Danger
            </AxTag>

            <AxTag
              color="warning"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Warning
            </AxTag>

            <AxTag color="info" prefix={<i className="fa-regular fa-plus"></i>}>
              Info
            </AxTag>

            <AxTag
              color="positive"
              prefix={<i className="fa-regular fa-plus"></i>}
            >
              Positive
            </AxTag>
          </Space>

          <Space>
            <AxTag
              color="default"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Medium
            </AxTag>

            <AxTag
              color="dynata"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Dynata
            </AxTag>

            <AxTag
              color="primary"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Primary
            </AxTag>

            <AxTag
              color="secondary"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Secondary
            </AxTag>

            <AxTag
              color="magenta"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Magenta
            </AxTag>

            <AxTag
              color="orange"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Orange
            </AxTag>

            <AxTag
              color="danger"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Danger
            </AxTag>

            <AxTag
              color="warning"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Warning
            </AxTag>

            <AxTag
              color="info"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Info
            </AxTag>

            <AxTag
              color="positive"
              suffix={<i className="fa-regular fa-xmark"></i>}
              selected
            >
              Positive
            </AxTag>
          </Space>
        </Space>
      </div>
    );
  }
}
export default Tags;
